import React from "react";
import { View, StyleSheet, Text } from "@react-pdf/renderer";
import ReportResourcesRow from "./Row";
import ReportResourcesHeader from "./Header";
import ReportResourcesFooter from "./Footer";

const tableRowsCount = 11;

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 4,
    borderWidth: 1,
    borderColor: "#bff0fd",
  },
  header: {
    fontSize: 16,
    // textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
    marginTop: 24,
  },
});

const ReportResourcesTable = ({ data }) => {
  if (!data) {
    return null;
  }
  const tables = data.map((list, index) => (
    <View key={index}>
      <Text style={styles.header}>{list.clientName}</Text>
      <View style={styles.tableContainer}>
        <ReportResourcesHeader />
        <ReportResourcesRow items={list} />
        <ReportResourcesFooter items={list} />
      </View>
    </View>
  ));

  return <View>{tables}</View>;
};

export default ReportResourcesTable;
